import React, { useState } from "react";

const DateRangePicker = ({ value, onChange, label }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [startDate, setStartDate] = useState(value?.start || "");
  const [endDate, setEndDate] = useState(value?.end || "");

  const handleDateChange = () => {
    onChange({ start: startDate, end: endDate });
    setIsOpen(false);
  };

  const formatDateRange = () => {
    if (value?.start && value?.end) {
      const start = new Date(value.start).toLocaleDateString('en-US', { 
        month: 'long', 
        day: 'numeric', 
        year: 'numeric' 
      });
      const end = new Date(value.end).toLocaleDateString('en-US', { 
        month: 'long', 
        day: 'numeric', 
        year: 'numeric' 
      });
      return `${start} - ${end}`;
    }
    return "Select date range";
  };

  return (
    <div className="mb-8">
      <div className="mb-2">
        <span className="text-base font-medium text-[#2a2a2a]">{label}</span>
      </div>
      <div className="relative">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="w-full border border-[#2a2a2a] rounded-md px-3 py-2 flex items-center text-left"
        >
          <svg className="w-4 h-4 text-[#2a2a2a] mr-2" viewBox="0 0 24 24" fill="currentColor">
            <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"/>
          </svg>
          <span className="text-xs text-[#2a2a2a]">{formatDateRange()}</span>
        </button>
        
        {isOpen && (
          <div className="absolute top-full left-0 right-0 bg-white border border-gray-300 rounded-md shadow-lg z-50 p-4 mt-1">
            <div className="space-y-3">
              <div>
                <label className="block text-xs font-medium text-[#2a2a2a] mb-1">Start Date</label>
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  className="w-full border border-gray-300 rounded px-2 py-1 text-xs"
                />
              </div>
              <div>
                <label className="block text-xs font-medium text-[#2a2a2a] mb-1">End Date</label>
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  className="w-full border border-gray-300 rounded px-2 py-1 text-xs"
                />
              </div>
              <div className="flex gap-2">
                <button
                  onClick={handleDateChange}
                  className="flex-1 bg-blue-500 text-white px-3 py-1 rounded text-xs hover:bg-blue-600"
                >
                  Apply
                </button>
                <button
                  onClick={() => setIsOpen(false)}
                  className="flex-1 bg-gray-300 text-gray-700 px-3 py-1 rounded text-xs hover:bg-gray-400"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DateRangePicker;
